<section class="cmn-innerpage-wrapper add-project-inventory">
  <h2 class="cmn-inner-heading">
    {{ supplierId ? 'Update Supplier' : 'Create New Supplier' }}
  </h2>

  <form [formGroup]="newSupplierForm" (ngSubmit)="onSubmit()">
    <div class="chart-account-form-wrapper">
      <div class="form-wrapper">
        <label for="">Supplier Name <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Supplier Name"
            formControlName="name"
          />
          <mat-error *ngIf="newSupplierForm.get('name')!.hasError('required')">
            Supplier Name is required.
          </mat-error>
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="newSupplierForm.get('name')!.hasError('maxlength')"
            >
              Supplier Name must be at most 50 characters long.
            </mat-error>
          </span>
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Code <span class="red">*</span></label>
        <mat-form-field>
          <input matInput placeholder="Enter Code" formControlName="code" readonly />
          <mat-error *ngIf="newSupplierForm.get('code')!.hasError('required')">
            Code is required.
          </mat-error>
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="newSupplierForm.get('code')!.hasError('maxlength')"
            >
              Code must be at most 50 characters long.
            </mat-error>
          </span>
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Address</label>
        <mat-form-field>
          <textarea
            matInput
            placeholder="Enter Address"
            formControlName="address"
          ></textarea>
        </mat-form-field>
      </div>
      <div class="form-wrapper">
        <label for="">Contact <span class="red">*</span></label>
        <mat-form-field>
          <input matInput placeholder="Enter Contact" formControlName="contactNumber" />
          
          <mat-error *ngIf="newSupplierForm.get('contactNumber')!.hasError('required')">
            Contact is required.
          </mat-error>
          <mat-error *ngIf="newSupplierForm.get('contactNumber')!.hasError('minlength')">
            Contact must be at least 8 digits long.
          </mat-error>
          <mat-error *ngIf="newSupplierForm.get('contactNumber')!.hasError('maxlength')">
            Contact must be at most 15 digits long.
          </mat-error>
          <mat-error *ngIf="newSupplierForm.get('contactNumber')!.hasError('pattern')">
            Contact must contain only numbers.
          </mat-error>
        </mat-form-field>
      </div>
      
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" type="button" (click)="onCancel()">
        Cancel
      </button>
      <button class="cmn-next-btn" type="submit">
        Save
      </button>
    </div>
  </form>
</section>
